export const SideNavLabel = {
  WELCOME: 'sidenav.quick_track_txt',
  DASHBOARD: 'sidenav.dashboard_txt',
  SHIPMENT: 'common.shipments_txt',
  OCEAN_SHIPMENT: 'common.ocean_shipments_txt',
  ROAD_SHIPMENT: 'common.road_shipments_txt',
  AIR_SHIPMENT: 'common.air_shipments_txt',
  OUTSOURCED_LOGISTICS: 'common.ol_shipments_txt',
  ORDERS: 'sidenav.orders_txt',
  INTEGRATED_ORDERS: 'Purchase Orders',
  SCHEDULES: 'Schedules',
  VESSEL_SCHEDULES: 'sidenav.vessel_schedules_txt',
  FLIGHT_SCHEDULES: 'Flight Schedules',
  INBOUND_CONTAINER_PICKUP: 'Inbound Container Pickup',
  CALENDAR: 'sidenav.calendar_txt',
  ANALYTICS: 'sidenav.analytics_txt',
  LOCATIONS: 'Locations'
};

export const SideNavRouteVsLabel = {
  '/welcome': SideNavLabel.WELCOME,
  '/dashboard': SideNavLabel.DASHBOARD,
  '/ocean-shipments': SideNavLabel.OCEAN_SHIPMENT,
  '/road-shipments': SideNavLabel.ROAD_SHIPMENT,
  '/air-shipments': SideNavLabel.AIR_SHIPMENT,
  '/outsourced-logistics': SideNavLabel.OUTSOURCED_LOGISTICS,
  '/orders': SideNavLabel.ORDERS,
  '/purchase-orders': SideNavLabel.INTEGRATED_ORDERS,
  '/vessel-schedules': SideNavLabel.VESSEL_SCHEDULES,
  '/flight-schedules': SideNavLabel.FLIGHT_SCHEDULES,
  '/container-pickup': SideNavLabel.INBOUND_CONTAINER_PICKUP,
  '/calendar': SideNavLabel.CALENDAR,
  '/performance': SideNavLabel.ANALYTICS,
};
